
import { CashFlowItem, ROIMetrics } from './types';
import { calculateNPV, calculatePaybackPeriod } from './cash-flow';

/**
 * Calculate ROI metrics for a project
 * @param cashFlowData - Array of cash flow data items
 * @param monthlyBurn - Current monthly burn rate
 * @param nextRoundDilution - Expected dilution from next funding round
 * @returns ROI metrics object
 */
export function calculateROIMetrics(
  cashFlowData: CashFlowItem[],
  monthlyBurn: number,
  nextRoundDilution: number
): ROIMetrics {
  const initialInvestment = Math.abs(cashFlowData[0].cashFlow);
  const totalCashFlow = cashFlowData.reduce((sum, item) => sum + item.cashFlow, 0);
  const roi = ((totalCashFlow - initialInvestment) / initialInvestment) * 100;
  const dcf = calculateNPV(cashFlowData);
  
  // Find break-even point
  let breakEvenPoint = calculatePaybackPeriod(cashFlowData);
  
  return {
    roi,
    burnRate: monthlyBurn,
    dcf,
    dilutionImpact: nextRoundDilution,
    breakEvenPoint
  };
}
